import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { RequisitoRespaldo } from '../../_models/requisito-respaldo';
import { Requisito } from '../../_models/requisito';
import { RequisitosRespaldosService } from '../../_services/requisitos-respaldos.service';
import { Producto } from '../../_models/producto';
import { ActividadEconomica } from '../../_models/actividad-economica';
import { ActividadEconomicaService } from '../../_services/actividad-economica.service';
import { ProductoService } from '../../_services/producto.service';
import { RequisitoRespaldoTipoVinculacion } from '../../_models/requisito-respaldo-tipo-vinculacion';
import { RequisitoRespaldoProducto } from '../../_models/requisito-respaldo-producto';
import { RequisitoRespaldoActividad } from '../../_models/requisito-respaldo-actividad';
import { GarantiasIdoneasActividades } from '../../_models/garantias-idoneas-actividades';
import { GarantiasIdoneasProducto } from '../../_models/garantias-idoneas-producto';
import { RequisitosRespaldosTipoVincuracionService } from '../../_services/requisitos-respaldos-tipo-vincuracion.service';
import { RequisitosRespaldosProductosService } from '../../_services/requisitos-respaldos-productos.service';
import { RequisitosRespaldosActividadesService } from '../../_services/requisitos-respaldos-actividades.service';
import { SolicitudUnidadCredito } from '../../_models/solicitud-unidad-credito';
import { CanalComunicacion, TipoActividadEconomica } from '../../_enums/enum';
import { ComunicationComponentsService } from '../../_services/comunication-components.service';
import {
  RequisitosGarantiasRespaldosTiposPersonasService
} from "../../_services/requisitos-garantias-respaldos-tipos-personas.service";
import {
  RequisitosGarantiasRespaldosOcupacionesService
} from "../../_services/requisitos-garantias-respaldos-ocupaciones.service";
import {RequisitosGarantiasRespaldosOcupaciones} from "../../_models/requisitos-garantias-respaldos-ocupaciones";
import {RequisitosGarantiasRespaldosTiposPersonas} from "../../_models/requisitos-garantias-respaldos-tipos-personas";
import {ex} from "@fullcalendar/core/internal-common";
import {Table} from 'primeng/table';
import { AdministradorDocumentoService } from '../../_services/administrador-documento.service';
import { log } from 'console';
import { AdministradorDocumento } from '../../_models/administrador-documento';

@Component({
  templateUrl: 'requisitos-respaldos-component.html',
  selector: 'app-requisito-respaldo',
  providers: [ConfirmationService]
})
export class RequisitosRespaldosComponent implements OnInit {

  @Input() requisito: Requisito;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() listasTiposOcupaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @ViewChild('dt', { static: true }) tabla: Table;
  lisRequisitosTodos: AdministradorDocumento[] = [];
  lisRequisitos: SelectItem[] = [];

  lisTipoVinculacionTodos: ListaItem[] = [];
  lisTipoVinculacion: SelectItem[] = [];

  lisProductosTodos: Producto[] = [];
  lisProductos: SelectItem[] = [];

  actFuente: ActividadEconomica[] = [];
  actSeleccionadas: ActividadEconomica[] = [];
  allActividades: ActividadEconomica[] = [];

  lisRequisitoRespaldo: RequisitoRespaldo[] = [];
  lisRequisitoRespaldoTodos: RequisitoRespaldo[] = [];
  cargando = true;
  formulario: FormGroup;
  submitted = false;
  columnas: any[] = [];

  lisRequisitosTipoVinculacion: RequisitoRespaldoTipoVinculacion[] = [];
  lisRequisitosProducto: RequisitoRespaldoProducto[] = [];
  lisRequisitosActividad: RequisitoRespaldoActividad[] = [];

  edit = false;
  selRespaldo: RequisitoRespaldo;
  detalle = false;
  tituloDetalle: string;
  textoDetalle: string;

  tipoActividad = TipoActividadEconomica;
  lisRequisitosGarantiasRespaldosOcupaciones: RequisitosGarantiasRespaldosOcupaciones[] = [];
  lisRequisitosGarantiasRespaldosTiposPersonas: RequisitosGarantiasRespaldosTiposPersonas[] = [];

  constructor(private navService: NavService,
    private router: Router,
    private fb: FormBuilder,
    private lisService: ListaService,
    private requisitosRespaldosServicio: RequisitosRespaldosService,
    private conService: ConfirmationService,
    private actividadEconomicaServicio: ActividadEconomicaService,
    private productosService: ProductoService,
    private requisitosTipoVinculacionService: RequisitosRespaldosTipoVincuracionService,
    private requisitosProductosService: RequisitosRespaldosProductosService,
    private requisitosActividadesService: RequisitosRespaldosActividadesService,
    private communicationService: ComunicationComponentsService,
    private requisitosGarantiasRespaldosTiposPersonasService: RequisitosGarantiasRespaldosTiposPersonasService,
    private requisitosGarantiasRespaldosOcupacionesService: RequisitosGarantiasRespaldosOcupacionesService,
    private administradorDocumentoService: AdministradorDocumentoService
  ) {
  }


  ngOnInit(): void {
    this.columnas = [
      {
        field: 'requisoto', header:
          this.navService.buscarMensaje('REQUISITOS.LBL_REQUISITOS'), sort: false
      },
      {
        field: 'tipoVinculacion', header:
          this.navService.buscarMensaje('REQUISITOS.LBL_TIPOVINCULACION'), sort: false
      },
      { field: 'productos', header: this.navService.buscarMensaje('REQUISITOS.LBL_PRODUCTO'), sort: false },
      { field: "naturaleza", header: this.navService.buscarMensaje("REQUISITOS.LBL_NATURALEZA"), sort: false},
      { field: "ocupacion", header: this.navService.buscarMensaje("FLUJOVENTACONSULTAS.LBL_OCUPACION"), sort: false},
      { field: 'actividades', header: this.navService.buscarMensaje('REQUISITOS.LBL_ACTIVIDAD'), sort: false },
      { field: 'det', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];

    forkJoin(
      this.administradorDocumentoService.getAllEnable(),
      this.lisService.getMasterDetails('ListasTiposVinculaciones'),
      this.productosService.listado(),
      this.actividadEconomicaServicio.listarPorTipo(this.tipoActividad.CLASE),


    ).
      subscribe(async ([lisRequisitos, lisTipoVinculacion,
        producto, actividades
      ]) => {
        console.log('Requisitos: ' + JSON.stringify(lisRequisitos, null, 2));
        this.lisRequisitosTodos = lisRequisitos;
        this.lisRequisitosTodos.sort((a, b) => a.orden - b.orden);
        this.lisTipoVinculacionTodos = lisTipoVinculacion;
        this.lisProductosTodos = producto.sort(function (a, b) {
          return a.orden - b.orden;
        });
        this.allActividades = actividades;

        await this.cargarListado();
        await this.cargarFormulario();
        await this.cargarFiltros();
        this.cargando = false;
      });
  }

  async cargarListado() {
    return new Promise(async resolve => {
      this.lisRequisitoRespaldo = [];
      this.lisRequisitosGarantiasRespaldosOcupaciones = [];
      this.lisRequisitosGarantiasRespaldosTiposPersonas = [];
      this.lisRequisitos = [];

      // Obtener los datos iniciales
      const lisRequisitosRespaldo = await this.requisitosRespaldosServicio.obtenerPorIdRequisito(this.requisito.idRequisitoGarantia).toPromise();
      this.lisRequisitoRespaldoTodos = lisRequisitosRespaldo;
      // Mapear los resultados de los requisitos respaldos
      const promises = lisRequisitosRespaldo.map(async (s) => {
        if (s.indicadorHabilitado) {
          const [data, tiposPersonas, ocupaciones] = await forkJoin([
            this.requisitosRespaldosServicio.obtenerPorGenerateList(s.idRequisitoGarantiaRespaldo),
            this.requisitosGarantiasRespaldosTiposPersonasService.busquedaRequisitoGarantiaRespaldo(s.idRequisitoGarantiaRespaldo),
            this.requisitosGarantiasRespaldosOcupacionesService.busquedaRequisitoGarantiaRespaldo(s.idRequisitoGarantiaRespaldo)
          ]).toPromise();

          if (data && data.requisitosGarantiasRespaldosTiposVinculaciones) {
            s.requisitosGarantiasRespaldosTiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones;
            s.tiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones.length > 45
              ? data.requisitosGarantiasRespaldosTiposVinculaciones.substring(0, 45)
              : data.requisitosGarantiasRespaldosTiposVinculaciones;
            s.verMasTiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones.length > 45;
          }

          if (data && data.requisitosGarantiasRespaldosActividades) {
            s.requisitosGarantiasRespaldosActividades = data.requisitosGarantiasRespaldosActividades;
            s.actividades = data.requisitosGarantiasRespaldosActividades.length > 45
              ? data.requisitosGarantiasRespaldosActividades.substring(0, 45)
              : data.requisitosGarantiasRespaldosActividades;
            s.verMasActividades = data.requisitosGarantiasRespaldosActividades.length > 45;
          }

          if (data && data.requisitosGarantiasRespaldosProductos) {
            s.requisitosGarantiasRespaldosProductos = data.requisitosGarantiasRespaldosProductos;
            s.productos = data.requisitosGarantiasRespaldosProductos.length > 45
              ? data.requisitosGarantiasRespaldosProductos.substring(0, 45)
              : data.requisitosGarantiasRespaldosProductos;
            s.verMasProductos = data.requisitosGarantiasRespaldosProductos.length > 45;
          }

          if (tiposPersonas && tiposPersonas.length > 0) {
            this.lisRequisitosGarantiasRespaldosTiposPersonas = this.lisRequisitosGarantiasRespaldosTiposPersonas.concat(tiposPersonas);
            let naturaleza = tiposPersonas.map(tp => tp.tipoPersona).join(', ');
            s.textoCompletoNaturaleza = naturaleza;
            s.textoNaturaleza = naturaleza.length > 45 ? naturaleza.substring(0, 45) : naturaleza;
            s.verMasNaturaleza = naturaleza.length > 45;
          }

          if (ocupaciones && ocupaciones.length > 0) {
            this.lisRequisitosGarantiasRespaldosOcupaciones = this.lisRequisitosGarantiasRespaldosOcupaciones.concat(ocupaciones);
            let ocupacionesText = ocupaciones.map(o => o.tipoOcupacion).join(', ');
            s.textoCompletoOcupaciones = ocupacionesText;
            s.textoOcupaciones = ocupacionesText.length > 45 ? ocupacionesText.substring(0, 45) : ocupacionesText;
            s.verMasOcupaciones = ocupacionesText.length > 45;
          }

          this.lisRequisitoRespaldo.push(s);
        }
      });

      // Esperar a que todas las promesas internas se resuelvan
      await Promise.all(promises);

      // Rellenar los requisitos adicionales
      this.lisRequisitosTodos.forEach(e => {
        if (!this.lisRequisitoRespaldoTodos.find(x => x.idRespaldo === e.idDocumentoTercero && x.indicadorHabilitado)) {
          this.lisRequisitos.push({ label: e.nombre, value: e.idDocumentoTercero });
        }
      });

      // Finalmente resolver la promesa principal
      resolve(true);
    });
  }

  async cargarFormulario() {
    this.formulario = this.fb.group({
      idRequisitoGarantiaRespaldo: [null],
      idRequisitoGarantia: [this.requisito.idRequisitoGarantia, [Validators.required]],
      idRespaldo: [null, [Validators.required]],
      idTipoVinculacion: [[]],
      idProducto: [[]],
      indicadorHabilitado: [true],
      idsOcupaciones: [[]],
      naturaleza: [[], [Validators.required]],
    });
    this.actSeleccionadas = [];
    this.edit = false;
  }

  async cargarFiltros() {

    this.lisTipoVinculacion = [];
    this.lisProductos = [];
    this.actFuente = [];

    this.lisTipoVinculacionTodos.forEach(e => {
      this.lisTipoVinculacion.push({ label: e.nombre, value: e.idLista });
    });

    this.lisProductosTodos.forEach(e => {
      if ( e.indicadorHabilitado )
        this.lisProductos.push({ label: e.nombre, value: e.idProducto });
    });

    this.allActividades.forEach(e => {
      if (e.indicadorHabilitado) {
        this.actFuente.push(e);
      }
    });
  }


  async onSubmit() {
    this.submitted = true;
    if (!this.formulario.valid) {
      return;
    }
    this.cargando = true;
    const registro = this.formulario.value;
    let respaldo = {} as RequisitoRespaldo;
    respaldo.indicadorHabilitado = true;
    respaldo.idRequisitoGarantia = this.requisito.idRequisitoGarantia;
    respaldo.idRespaldo = registro.idRespaldo;
    const existe = this.lisRequisitoRespaldoTodos.find(x => x.idRespaldo === registro.idRespaldo);
    if (existe) {
      respaldo.idRequisitoGarantiaRespaldo = existe.idRequisitoGarantiaRespaldo;
    }
    const requisitoRespaldo = await (existe ? this.requisitosRespaldosServicio.crear(respaldo) :
      this.requisitosRespaldosServicio.actualizar(respaldo)).toPromise();

    if (requisitoRespaldo && requisitoRespaldo.idRequisitoGarantiaRespaldo) {
      forkJoin(
        this.requisitosTipoVinculacionService.obtenerPorIdRequisito(requisitoRespaldo.idRequisitoGarantiaRespaldo),
        this.requisitosProductosService.obtenerPorIdRequisito(requisitoRespaldo.idRequisitoGarantiaRespaldo),
        this.requisitosActividadesService.obtenerPorIdRequisito(requisitoRespaldo.idRequisitoGarantiaRespaldo)).
        subscribe(([lisTipoVinculacion, producto, actividades]) => {

          const tempTipoVinculacion: RequisitoRespaldoTipoVinculacion[] = [];
          registro.idTipoVinculacion.forEach(tipoVinculacion => {
            let temp = {} as RequisitoRespaldoTipoVinculacion;
            temp.idRequisitoGarantiaRespaldo = requisitoRespaldo.idRequisitoGarantiaRespaldo;
            temp.idTipoVinculacion = tipoVinculacion;
            temp.indicadorHabilitado = true;
            const a = lisTipoVinculacion.find(sp => sp.idTipoVinculacion === temp.idTipoVinculacion);
            if (a) {
              temp.idRequisitoGarantiaRespaldoTipoVinculacion = a.idRequisitoGarantiaRespaldoTipoVinculacion;
            }
            tempTipoVinculacion.push(temp);
          });
          lisTipoVinculacion.forEach(e => {
            if (e.indicadorHabilitado && !registro.idTipoVinculacion.find(y => y === e.idTipoVinculacion)) {
              e.indicadorHabilitado = false;
              tempTipoVinculacion.push(e);
            }
          });

          const tempProducto: RequisitoRespaldoProducto[] = [];
          registro.idProducto.forEach(idProducto => {
            let temp = {} as RequisitoRespaldoProducto;
            temp.idRequisitoGarantiaRespaldo = requisitoRespaldo.idRequisitoGarantiaRespaldo;
            temp.idProducto = idProducto;
            temp.indicadorHabilitado = true;
            const a = producto.find(sp => sp.idProducto === temp.idProducto);
            if (a) {
              temp.idRequisitoGarantiaRespaldoProducto = a.idRequisitoGarantiaRespaldoProducto;
            }
            tempProducto.push(temp);
          });
          producto.forEach(e => {
            if (e.indicadorHabilitado && !registro.idProducto.find(y => y === e.idProducto)) {
              e.indicadorHabilitado = false;
              tempProducto.push(e);
            }
          });

          const tempActividad: RequisitoRespaldoActividad[] = [];
          this.lisRequisitosActividad.forEach(actividad => {
            let temp = {} as RequisitoRespaldoActividad;
            temp = actividad;
            temp.idRequisitoGarantiaRespaldo = requisitoRespaldo.idRequisitoGarantiaRespaldo;
            const a = actividades.find(sp => sp.idActividad === temp.idActividad);
            if (a) {
              temp.idRequisitoGarantiaRespaldoActividad = a.idRequisitoGarantiaRespaldoActividad;
            }
            tempActividad.push(temp);
          });

          if (requisitoRespaldo.idRequisitoGarantiaRespaldo) {
            actividades.forEach(a => {
              if (a.idRequisitoGarantiaRespaldo === requisitoRespaldo.idRequisitoGarantiaRespaldo && !tempActividad.find(x => x.idActividad === a.idActividad) && a.indicadorHabilitado) {
                a.indicadorHabilitado = false;
                tempActividad.push(a);
              }
            });
          }

          forkJoin(
            this.guardarTipoVinculacion(tempTipoVinculacion),
            this.guardarProductos(tempProducto),
            this.guardarActividades(tempActividad),
            this.guardarRequisitosRespaldosOcupaciones(this.lisRequisitosGarantiasRespaldosOcupaciones.filter(x => x.idRequisitoGarantiaRespaldo === requisitoRespaldo.idRequisitoGarantiaRespaldo), registro.idsOcupaciones, requisitoRespaldo.idRequisitoGarantiaRespaldo),
            this.guardarRequisitosRespaldosTipoPersona(this.lisRequisitosGarantiasRespaldosTiposPersonas.filter(x => x.idRequisitoGarantiaRespaldo === requisitoRespaldo.idRequisitoGarantiaRespaldo), registro.naturaleza, requisitoRespaldo.idRequisitoGarantiaRespaldo)
          ).subscribe(r => {
            this.reiniciar();
          });
        });
    }
  }

  async guardarRequisitosRespaldosTipoPersona(registros: RequisitosGarantiasRespaldosTiposPersonas[], seleccionados: string[], idRequisitoGarantiaRespaldo: string) {
    let temp: RequisitosGarantiasRespaldosTiposPersonas[] = [];
    seleccionados.forEach(e => {
      let obj = {} as RequisitosGarantiasRespaldosTiposPersonas;
      const existe = registros.find(x => x.idTipoPersona === e);
      if (!!existe) {
        obj = existe;
        obj.indicadorHabilitado = true;
      } else {
        obj.idRequisitoGarantiaRespaldo = idRequisitoGarantiaRespaldo;
        obj.idTipoPersona = e;
        obj.indicadorHabilitado = true;
      }
      temp.push(obj);
    });
    registros.forEach(e => {
      const inhabilitar = seleccionados.find(x => x === e.idTipoPersona);
      if (!inhabilitar) {
        e.indicadorHabilitado = false;
        temp.push(e);
      }
    });
    await this.requisitosGarantiasRespaldosTiposPersonasService.bulk(temp).toPromise();
  }

  async guardarRequisitosRespaldosOcupaciones(registros: RequisitosGarantiasRespaldosOcupaciones[], seleccionados: string[], idRequisitoGarantiaRespaldo: string) {
    let temp: RequisitosGarantiasRespaldosOcupaciones[] = [];
    seleccionados.forEach(e => {
      let obj = {} as RequisitosGarantiasRespaldosOcupaciones;
      const existe = registros.find(x => x.idTipoOcupacion === e);
      if (!!existe) {
        obj = existe;
        obj.indicadorHabilitado = true;
      } else {
        obj.idRequisitoGarantiaRespaldo = idRequisitoGarantiaRespaldo;
        obj.idTipoOcupacion = e;
        obj.indicadorHabilitado = true;
      }
      temp.push(obj);
    });
    registros.forEach(e => {
      const inhabilitar = seleccionados.find(x => x === e.idTipoOcupacion);
      if (!inhabilitar) {
        e.indicadorHabilitado = false;
        temp.push(e);
      }
    });
    await this.requisitosGarantiasRespaldosOcupacionesService.bulk(temp).toPromise();
  }

  get f() {
    return this.formulario.controls;
  }

  inhablitar(registro: RequisitoRespaldo) {
    this.conService.confirm({
      message: this.navService.buscarMensaje('MSG_INHABILITAR'),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: `tipo-respaldo`,
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.requisitosRespaldosServicio.actualizar(registro).subscribe(async r => {
          this.navService.setMesage(2);
          await this.cargarListado();
          await this.cargarFiltros();
          this.cargando = false;
        });
      }
    });
  }

  /* emitinir mensaje para actualizar lista en requisito producto */
  emitir(accion: string) {
    this.communicationService.emitir({
      canal: CanalComunicacion.ACTUALIZARREQUISITORESPALDO,
      mensaje: { accion: accion }
    });
  }

  async reiniciar() {
    this.emitir('actualizar');
    await this.cargarListado();
    await this.cargarFiltros();
    this.reiniciarForm();
    this.lisRequisitosActividad = [];
    this.navService.setMesage(1);
    this.cargando = false;
  }

  reiniciarForm() {
    this.submitted = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
  }

  guardar(event: ActividadEconomica[], seleccionado: boolean) {
    event.map(e => {
      const a = this.lisRequisitosActividad
        .findIndex(sa => sa.idActividad === e.idActividadEconomica);

      let temp = {} as RequisitoRespaldoActividad;

      temp.idRequisitoGarantiaRespaldoActividad = a >= 0 ?
        this.lisRequisitosActividad[a].idRequisitoGarantiaRespaldoActividad : null;
      temp.idActividad = e.idActividadEconomica;
      temp.actividad = e.actividadEconomica;
      temp.indicadorHabilitado = seleccionado;

      if (a >= 0) {
        this.lisRequisitosActividad[a].indicadorHabilitado = seleccionado;
      } else {
        this.lisRequisitosActividad.push(temp);
      }
    });
  }


  async guardarTipoVinculacion(event: any[]) {
    if (event.length > 0) {
      const requisitoRespaldo = await this.requisitosTipoVinculacionService.bulk(event).toPromise();
    }
    return true;
  }

  async guardarProductos(event: any[]) {
    if (event.length > 0) {
      const requisitoRespaldo = await this.requisitosProductosService.bulk(event).toPromise();
    }
    return true;
  }

  async guardarActividades(event: any[]) {
    if (event.length > 0) {
      const requisitoRespaldo = await this.requisitosActividadesService.bulk(event).toPromise();
    }
    return true;
  }


  editar(row: RequisitoRespaldo) {
    this.cargando = true;
    this.edit = true;
    forkJoin(
      this.requisitosTipoVinculacionService.obtenerPorIdRequisito(row.idRequisitoGarantiaRespaldo),
      this.requisitosProductosService.obtenerPorIdRequisito(row.idRequisitoGarantiaRespaldo),
      this.requisitosActividadesService.obtenerPorIdRequisito(row.idRequisitoGarantiaRespaldo)).
      subscribe(([lisTipoVinculacion, producto, actividades]) => {
        this.lisRequisitosTipoVinculacion = [];
        this.lisRequisitosTipoVinculacion = lisTipoVinculacion;

        this.lisRequisitosProducto = [];
        this.lisRequisitosProducto = producto;

        this.lisRequisitosActividad = [];
        this.actSeleccionadas = [];
        this.actFuente = [];
        this.lisRequisitosActividad = actividades;

        this.allActividades.map(ae => {
          if (this.lisRequisitosActividad.find(sa => sa.
            idActividad === ae.idActividadEconomica && sa.indicadorHabilitado)) {
            this.actSeleccionadas.push(ae);
          } else {
            if (ae.indicadorHabilitado) {
              this.actFuente.push(ae);
            }
          }
        });
        const tipoVinculaciones = [];
        const productos = [];
        this.lisRequisitosTipoVinculacion.forEach(e => {
          if (e.indicadorHabilitado) {
            tipoVinculaciones.push(e.idTipoVinculacion);
          }
        });
        this.lisRequisitosProducto.forEach(e => {
          if (e.indicadorHabilitado) {
            productos.push(e.idProducto);
          }
        });
        this.f.idTipoVinculacion.setValue(tipoVinculaciones);
        this.f.idProducto.setValue(productos);
        this.f.idRespaldo.setValue(row.idRespaldo);
        this.f.naturaleza.setValue(this.lisRequisitosGarantiasRespaldosTiposPersonas.filter(x => x.idRequisitoGarantiaRespaldo === row.idRequisitoGarantiaRespaldo).map(e => e.idTipoPersona));
        this.f.idsOcupaciones.setValue(this.lisRequisitosGarantiasRespaldosOcupaciones.filter(x => x.idRequisitoGarantiaRespaldo === row.idRequisitoGarantiaRespaldo).map(e => e.idTipoOcupacion));
        this.selRespaldo = row;
        this.cargando = false;
      });
  }

  detalleTabla(row: RequisitoRespaldo, tipo: string) {
    this.selRespaldo = row;
    //this.tituloDetalle ="Detalle";
    if (tipo === "tipoVincularion") {
      this.tituloDetalle = this.navService.buscarMensaje('REQUISITOS.LBL_TIPOVINCULACION');
      this.textoDetalle = row.requisitosGarantiasRespaldosTiposVinculaciones;
    } else if (tipo === "producto") {
      this.tituloDetalle = this.navService.buscarMensaje('REQUISITOS.LBL_PRODUCTO');
      this.textoDetalle = row.requisitosGarantiasRespaldosProductos;
    } else if (tipo === "actividad") {
      this.tituloDetalle = this.navService.buscarMensaje('REQUISITOS.LBL_ACTIVIDAD');
      this.textoDetalle = row.requisitosGarantiasRespaldosActividades;
    } else if (tipo === "naturaleza") {
      this.tituloDetalle = this.navService.buscarMensaje('REQUISITOS.LBL_NATURALEZA');
      this.textoDetalle = row.textoCompletoNaturaleza;
    } else if (tipo === "ocupaciones") {
      this.tituloDetalle = this.navService.buscarMensaje('FLUJOVENTACONSULTAS.LBL_OCUPACION');
      this.textoDetalle = row.textoCompletoOcupaciones;
    }
    this.detalle = true;
  }

}
